function p(s, t, u = !0) {
  return s.split(" ").every((r) => {
    const n = t.some((e) => u ? r === e || r === `${e}@xs` || r === `${e}@sm` || r === `${e}@md` || r === `${e}@lg` : r === e);
    return n || console.error(`Invalid prop value: ${r}`), n;
  });
}
export {
  p as default
};
